import axios from 'axios';
import { IUserActivityTracking } from '../../../interfaces/User.interfaces';
import { customAxios } from '../../common/customAxios';

export const getUserActivityTracking = (): Promise<IUserActivityTracking[]> => {
  return customAxios.get('/user-activity-tracking');
};
